import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import QueryString from "query-string";
import { Link as RouterLink } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Pagination from "@material-ui/lab/Pagination";

import pageTitle from "../../utils/pageTitle";
import NotFound from "../NotFound";
import history from "../../store/history";
import Axios from "../../utils/axios";
import { ADM_AREAS_LOCATION_LIST_URL, RECORDS_FETCH_LIMIT } from "../../config";
import { showErrorAlert } from "../../store/actions/alerts";
import ResultGrid from "../../components/location/ResultGrid";
import ComponentLoader from "../../components/loader/ComponentLoader";

export default function AdmAreaLocations({ location, match }) {
  const dispatch = useDispatch();
  const admId = match.params.admId;
  const [notFound, setNotFound] = useState(false);
  const [result, setResult] = useState(null);
  const [noResult, setNoResult] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  useEffect(() => {
    pageTitle("Administrative Area");
    const query = QueryString.parse(location.search);
    let page = 1;
    let limit = RECORDS_FETCH_LIMIT;

    if (!!query) {
      page = Number(query.page) || page;
      limit = Number(query.limit) || limit;
    }

    setIsloading(true);
    const axiosInstance = new Axios();
    axiosInstance
      .request({
        url: `${ADM_AREAS_LOCATION_LIST_URL.url}/${admId}`,
        method: ADM_AREAS_LOCATION_LIST_URL.method,
        params: {
          page,
          limit,
        },
      })
      .then((response) => {
        setIsloading(false);
        if (response.data.admId) {
          setResult(response.data);
          pageTitle(response.data.name);
          response.data.locations && response.data.locations.length > 0
            ? setNoResult(false)
            : setNoResult(true);
        }
      })
      .catch((error) => {
        setIsloading(false);
        if (!!error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          dispatch(
            showErrorAlert(
              "Error : " +
                (!!error.response
                  ? `${error.response.status}! - ${error.response.data.errorMessage}`
                  : error.message)
            )
          );
        }
      });

    // eslint-disable-next-line
  }, []); // [] is required to make sure that it runs only once

  const handlePagination = (e, page) => {
    const query = QueryString.parse(location.search);
    const pathName = location.pathname;
    history.push(
      `${pathName}?${QueryString.stringify({
        ...query,
        page,
      })}`
    );
  };

  return (
    <Fragment>
      {!notFound ? (
        <Container style={{ padding: "10px" }}>
          <ComponentLoader isLoading={isLoading} />

          {result && (
            <Paper style={{ padding: "15px" }}>
              <Link
                color="inherit"
                variant="h6"
                component={RouterLink}
                to={`/adm-areas/${result.admId}`}
                underline="none"
              >
                {result.name}
              </Link>
            </Paper>
          )}

          {!isLoading && !noResult && result && (
            <Fragment>
              <Typography
                variant="caption"
                color="textSecondary"
                style={{ margin: "15px" }}
                display="block"
                gutterBottom
              >
                {result.stats &&
                  `Total Location(s) : ${result.stats.records.total}, Fetched : ${result.stats.records.fetched}, Page : ${result.stats.pages.current}`}
              </Typography>
              {result.locations &&
                result.locations.map((location) => {
                  return <ResultGrid location={location} key={location.id} />;
                })}
              <Box
                justifyContent="center"
                display="flex"
                style={{ margin: "20px" }}
              >
                <Pagination
                  count={result.stats.pages.total}
                  page={result.stats.pages.current}
                  boundaryCount={3}
                  color="primary"
                  shape="rounded"
                  variant="outlined"
                  onChange={handlePagination}
                />
              </Box>
            </Fragment>
          )}
          {!isLoading && noResult && (
            <Box
              justifyContent="center"
              display="flex"
              style={{ marginTop: "30px" }}
            >
              No Location Found !!
            </Box>
          )}
        </Container>
      ) : (
        <NotFound />
      )}
    </Fragment>
  );
}
